

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import vSelect from "vue-select"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"

import CCEvent from "./CCEvent.vue"

import { CaseDetails, CaseField, CaseAudit } from "@/types"
import CaseFile from "@/types/caseFile"

import { CaseEvent, CaseEvents } from "@/types/originatingEvents"

import api from "@/services/api"

const caseStore = namespace("cases")

@Component({
	components: {
		"cc-event": CCEvent
	}
})
export default class CCEventModal extends Vue {
	$refs!: {
		eventModal: BModal
	}

	@Prop()
	public currentCase!: CaseDetails;

	@Prop()
	canEditCurrentCase!: boolean;

	@Prop({ default: () => null })
	public caseEvents!: CaseEvents | null;

	@caseStore.State("showCCEvent")
	public ccEvent!: CaseEvent;

	@caseStore.Mutation
	public setShowCCEvent!: (ccEvent: CaseEvent) => void;

	@Watch("ccEvent")
	onEventChanged (newValue: any) {
		if (newValue) {
			this.$refs.eventModal.show()
		} else {
			this.$refs.eventModal.hide()
		}
	}
}
